import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useShortIdContext } from "@air/provider-short-id";
import { useRouter } from "next/router";
import { memo, useCallback } from "react";
import { AnonymousSignUpFormWrapper } from "~/components/AnonymousSignUpForm/AnonymousSignUpFormWrapper";
import { AnonymousSignUpModal } from "~/components/PublicLinkAnonymousSignUpModal/AnonymousSignUpModal";
import { useAnonymousSignUpModalLogic } from "~/components/PublicLinkAnonymousSignUpModal/hooks/useAnonymousSignUpModalLogic";
import { AnonymousSignUpModalHeader } from "~/components/PublicLinkAnonymousSignUpModal/shared/AnonymousSignUpModalHeader";
export const PublicAssetAnonymousSignUpModal = /*#__PURE__*/ memo((param)=>{
    let { onClose, onLoggedIn } = param;
    const { asPath } = useRouter();
    const { shortId, objectId } = useShortIdContext();
    const _onLoggedIn = useCallback(()=>{
        onClose();
        onLoggedIn === null || onLoggedIn === void 0 ? void 0 : onLoggedIn();
    }, [
        onClose,
        onLoggedIn
    ]);
    const { onFullLoginClick, isOpen } = useAnonymousSignUpModalLogic({
        ssoCallbackData: {
            url: asPath
        },
        onLoginSuccess: _onLoggedIn
    });
    return /*#__PURE__*/ _jsxs(AnonymousSignUpModal, {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ _jsx(AnonymousSignUpModalHeader, {
                alt: "Clouds with paper plane",
                imageSrc: "/assets/illustrations/clouds-paper-plane.svg"
            }),
            /*#__PURE__*/ _jsx(AnonymousSignUpFormWrapper, {
                title: "A file was shared with you!",
                description: "Please enter your info to continue.",
                onLoggedIn: _onLoggedIn,
                onFullLoginClick: onFullLoginClick,
                objectType: "clip",
                trackLocation: "clip-share-link",
                objectId: objectId,
                shortId: shortId
            })
        ]
    });
});
PublicAssetAnonymousSignUpModal.displayName = "PublicLinkAnonymousSignUpModal";
